import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/helper.js');
require('./js/init.js');
require('./js/carousel.js');
require('./js/fonts.js');
require('./js/gototarget.js');
require('./js/gsap.js');
require('./js/ismobile.js');
require('./js/map.js');
require('./js/nav.js');
require('./js/faq.js');
require('./js/overlay.js');
require('./js/form.js');
//require('./js/map-markers.js');
require('./js/popup.js');
require('./js/quiz.js');
require('./js/waypoints.js');


// Images
require('./img/alumini-program/01.jpg');
require('./img/alumini-program/01@2x.jpg');

require('./img/are-we-perfect-match/01.jpg');
require('./img/are-we-perfect-match/01@2x.jpg');

require('./img/career-areas/0R2A3200.jpg');
require('./img/career-areas/0R2A3200@2x.jpg');

require('./img/bigmenu/grow-with-us.jpg');
require('./img/bigmenu/grow-with-us@2x.jpg');
require('./img/bigmenu/join-us.jpg');
require('./img/bigmenu/join-us@2x.jpg');
require('./img/bigmenu/meet-us.jpg');
require('./img/bigmenu/meet-us@2x.jpg');
require('./img/bigmenu/stay-with-us.jpg');
require('./img/bigmenu/stay-with-us@2x.jpg');

require('./img/faq/01.jpg');
require('./img/faq/01@2x.jpg');

require('./img/hero/bring--big.jpg');
require('./img/hero/bring--big@2x.jpg');
require('./img/hero/bring--medium.jpg');
require('./img/hero/bring--medium@2x.jpg');
require('./img/hero/bring--small.jpg');
require('./img/hero/bring--small@2x.jpg');

require('./img/how-to-join-us/01.jpg');
require('./img/how-to-join-us/01@2x.jpg');

require('./img/news-big.jpg');
require('./img/news-big2.jpg');
require('./img/news/market.jpg');
require('./img/news/market@2x.jpg');
require('./img/news/partners.jpg');
require('./img/news/partners@2x.jpg');
require('./img/news/press.jpg');
require('./img/news/press@2x.jpg');

require('./img/our-people/marek.jpg');

require('./img/our-culture/01.jpg');
require('./img/our-culture/01@2x.jpg');
require('./img/our-culture/02.png');
require('./img/our-culture/02@2x.png');

require('./img/our-impact/01.jpg');
require('./img/our-impact/01@2x.jpg');

require('./img/our-story/1993.jpg');
require('./img/our-story/1993@2x.jpg');
require('./img/our-story/1995.jpg');
require('./img/our-story/1995@2x.jpg');
require('./img/our-story/1998.jpg');
require('./img/our-story/1998@2x.jpg');
require('./img/our-story/2004.jpg');
require('./img/our-story/2004@2x.jpg');
require('./img/our-story/2005.jpg');
require('./img/our-story/2005@2x.jpg');
require('./img/our-story/2006.jpg');
require('./img/our-story/2006@2x.jpg');
require('./img/our-story/2007.jpg');
require('./img/our-story/2007@2x.jpg');
require('./img/our-story/2008.jpg');
require('./img/our-story/2008@2x.jpg');
require('./img/our-story/2010.jpg');
require('./img/our-story/2010@2x.jpg');
require('./img/our-story/2011.jpg');
require('./img/our-story/2011@2x.jpg');
require('./img/our-story/2012.jpg');
require('./img/our-story/2012@2x.jpg');
require('./img/our-story/2014.jpg');
require('./img/our-story/2014@2x.jpg');
require('./img/our-story/2015.jpg');
require('./img/our-story/2015@2x.jpg');
require('./img/our-story/2017.jpg');
require('./img/our-story/2017@2x.jpg');
require('./img/our-story/2018.jpg');
require('./img/our-story/2018@2x.jpg');
require('./img/our-story/2019.jpg');
require('./img/our-story/2019@2x.jpg');

require('./img/photos/thumb-4.jpg');
require('./img/photos/thumb-4@2x.jpg');
require('./img/photos/user@2x.jpg');

require('./img/place-of-possible/image-01.jpg');
require('./img/place-of-possible/image-01@2x.jpg');

require('./img/reasons-to-join-us/0R2A2863.jpg');
require('./img/reasons-to-join-us/0R2A2863@2x.jpg');
require('./img/reasons-to-join-us--exponential/0R2A2041.jpg');
require('./img/reasons-to-join-us--exponential/0R2A2041@2x.jpg');
require('./img/reasons-to-join-us--we/0R2A2127.jpg');
require('./img/reasons-to-join-us--we/0R2A2127@2x.jpg');
require('./img/reasons-to-join-us--work/0R2A3438.jpg');
require('./img/reasons-to-join-us--work/0R2A3438@2x.jpg');
require('./img/reasons-to-join-us--together/0R2A2853.jpg');
require('./img/reasons-to-join-us--together/0R2A2853@2x.jpg');
require('./img/reasons-to-join-us--spread/0R2A2198.jpg');
require('./img/reasons-to-join-us--spread/0R2A2198@2x.jpg');

require('./img/social/social.jpg');
require('./img/social/social@2x.jpg');

require('./img/stories/stories-01.jpg');
require('./img/stories/stories-01@2x.jpg');
require('./img/stories/stories-02.jpg');
require('./img/stories/stories-02@2x.jpg');
require('./img/stories/stories-03.jpg');
require('./img/stories/stories-03@2x.jpg');
require('./img/stories/stories-04.jpg');
require('./img/stories/stories-04@2x.jpg');

require('./img/dora/CT2.jpg');
require('./img/dora/NSO.jpg');
require('./img/dora/Tanzania.jpg');
require('./img/dora/Team.jpg');
require('./img/dora/Howard.jpg');

require('./img/joy/Joy3.jpg');
require('./img/joy/Joy4.jpg');
require('./img/joy/Joy5.jpg');

require('./img/join-us.jpg');
require('./img/join-us-mobile.jpg');
